import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import AuthCard from '../components/AuthCard';
import CodeInput from '../components/CodeInput';
import { Alert, SubmitButton } from '../components/Feedback';
import { usePspAuth } from '../context/PspAuthContext';
import { candidateApi } from '../services/pspApi';
import { PENDING_EMAIL_KEY } from './Register';

const VerifyEmail = () => {
    const { friendly_url } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated, signIn } = usePspAuth();
    const base = `/processos-seletivos/${friendly_url}`;

    const email = (location.state && location.state.email) || sessionStorage.getItem(PENDING_EMAIL_KEY);

    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [info, setInfo] = useState('');
    const [loading, setLoading] = useState(false);
    const [resending, setResending] = useState(false);
    const [restart, setRestart] = useState(false);

    if (isAuthenticated) return <Navigate to={`${base}/home`} replace />;
    if (!email) return <Navigate to={`${base}/cadastro`} replace />;

    const handleSubmit = async (event) => {
        if (event) event.preventDefault();
        if (code.length !== 6) {
            setError('Informe o código de 6 dígitos.');
            return;
        }

        setError('');
        setInfo('');
        setLoading(true);
        const result = await candidateApi.verifyEmail(email, code);
        setLoading(false);

        if (result && result.status === 1) {
            sessionStorage.removeItem(PENDING_EMAIL_KEY);
            signIn(result.token, result.candidate);
            navigate(`${base}/home`, { replace: true });
            return;
        }

        setCode('');
        setError((result && result.message) || 'Não foi possível confirmar o código.');
        if (result && result.restart) {
            sessionStorage.removeItem(PENDING_EMAIL_KEY);
            setRestart(true);
        }
    };

    const handleResend = async () => {
        setError('');
        setInfo('');
        setResending(true);
        const result = await candidateApi.resendCode(email, 'cadastro');
        setResending(false);

        if (result && result.status === 1) {
            setCode('');
            setInfo(`Enviamos um novo código. Reenvios restantes: ${result.remaining_resends - 1 < 0 ? 0 : result.remaining_resends - 1}.`);
        } else {
            setError((result && result.message) || 'Não foi possível reenviar o código.');
            if (result && result.restart) {
                sessionStorage.removeItem(PENDING_EMAIL_KEY);
                setRestart(true);
            }
        }
    };

    return (
        <div className="psp-center psp-center--padded">
            <AuthCard
                icon="fa-envelope-open-text"
                title="Confirme seu e-mail"
                subtitle={`Enviamos um código de 6 dígitos para ${email}. Ele é válido por 1 hora.`}
                onBack={() => navigate(`${base}/cadastro`)}
            >
                <form className="psp-stack" onSubmit={handleSubmit}>
                    <Alert type="error">{error}</Alert>
                    <Alert type="success">{info}</Alert>

                    {restart ? (
                        <button type="button" className="psp-btn psp-btn--primary" onClick={() => navigate(`${base}/cadastro`)}>
                            Refazer cadastro
                        </button>
                    ) : (
                        <>
                            <CodeInput value={code} onChange={setCode} disabled={loading} />
                            <SubmitButton loading={loading}>Confirmar</SubmitButton>
                            <div className="psp-text-center">
                                <button type="button" className="psp-link" onClick={handleResend} disabled={resending}>
                                    {resending ? 'Reenviando...' : 'Reenviar código'}
                                </button>
                            </div>
                        </>
                    )}
                </form>
            </AuthCard>
        </div>
    );
};

export default VerifyEmail;
